import { createContext, useContext } from 'react';

export const Context = createContext();
Context.displayName = 'HeaderWrapperContext';

export const HeaderWrapperContext = () => useContext(Context);
